import { graphql } from '@/graphql/__generated/gql';

export const cacheKey = 'regionalConfiguration';
export const document = /* GraphQL */ `
    query RegionalConfiguration($region: String!) {
        regionalConfiguration(region: $region)
    }
`;
export const query = graphql(document);
